import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import { useGlobal } from '@/utils/useGlobal';
import { saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import EcoButton from 'eco-design/base/eco-button';
import EcoButtonDouble from 'eco-design/base/eco-button-double';
import EcoImg from 'eco-design/base/eco-img';
import EcoSection from 'eco-design/base/eco-section';
import EcoSpace from 'eco-design/base/eco-space';
import React, { useEffect, useState } from 'react';
import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import style from './index.module.scss';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design-components/elements/eco-cart/type.d';

interface Props {
    item: any;
    id: string;
}

const PcComp: React.FC<Props> = ({ item, id }) => {
    const { t } = useLang('powerbackup.Preparing');
    const { t: s } = useLang('powerbackup');
    const { getSystemTime, useRouter } = useGlobal();
    const [isRegular, setIsRegular] = useState(false);
    const router = useRouter();
    const { locale } = getLocal();
    let systemTime = getSystemTime();
    const { _timer } = router.query;
    if (_timer) {
        systemTime = new Date(_timer).getTime();
    }
    useEffect(() => {
        if (systemTime >= new Date('2025/11/03 16:00:00 GMT+8').getTime()) {
            setIsRegular(true);
        }
    }, []);
    const handleBuy = (card: any) => {
        try {
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            const addCarts: ItfEcoCartItem[] = [
                {
                    price: card?.price || 0,
                    compareAtPrice: card?.compareAtPrice || 0,
                    inventoryQuantity: card?.inventoryQuantity || 0,
                    inventoryPolicy: card?.inventoryPolicy || 'deny',
                    productId: card?.productId,
                    variantId: card?.variantId,
                    variantImg: card?.variantImg || '',
                    img: card?.img || '',
                    skuTitle: card?.skuTitle || '',
                    productTitle: card?.productTitle || '',
                    quantity: 1,
                } as ItfEcoCartItem,
            ];
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, addCarts);
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                product_name: card?.title || card?.productTitle || card?.skuTitle,
                list_name: item?.title,
                price: card?.price,
                tag: 'none',
                quantity: 1,
                button_name: s('common_card_buy'),
            });
            saveAICookieForShopify(`https://${locale}.ecoflow.com/cart/${card?.variantId}:1?channel=buy_button`, locale, true);
        }
    };

    const handleLearnMore = (card?: any) => {
        saveAICookieForShopify(`https://${locale}.ecoflow.com/products/${card.handle}?variant=${card.variantId}`, locale);

        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: card.skuTitle,
            position: 'In-Products Module',
        });

        gtm.push({
            event: 'uaEvent',
            event_name: 'select_product',
            list_name: item.title,
            product_name: card.skuTitle,
            button_name: t('btn2'),
        });
    };

    const handleFormatProductTitle = (info: any) => {
        // 只处理d3mp 和 d3up
        if (
            info?.variantId === '54718699962441' ||
            info?.variantId === '54718705008713' ||
            info?.variantId === '62106661618035' ||
            info?.variantId === '62106740556147'
        ) {
            // 如果 skuTitle 包含 "/"，返回 "/" 前的部分
            return info?.title?.split('/')?.[0]?.trim() || info?.skuTitle?.split('/')?.[0]?.trim();
        }
        return info?.title || info?.skuTitle;
    };

    return (
        <div className={style.PCComp} id={id}>
            <EcoSpace />
            <div className="top">
                <EcoImg className="bg" pc={item?.pc} pad={item?.pad} h5={item?.h5} />
                <div className="info">
                    <EcoSection className="info-section" label={item?.label} title={item?.title} desc={item?.desc} />
                    <div className="icons">
                        {item?.icons?.map?.((i, idx) => (
                            <div className="icon-item" key={idx}>
                                <EcoImg className="icon" pc={i.pc} />
                                <div className="icon-text">{i.text}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {item?.products && (
                <Swiper
                    className="footer-swiper"
                    slidesPerView={'auto'}
                    modules={[Scrollbar, Navigation]}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 25,
                        snapOnRelease: true,
                    }}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                >
                    {item?.products?.map?.((i, idx) => (
                        <SwiperSlide className="footer-swiper-slide" key={idx}>
                            <EcoImg className="product-img" pc={i?.variantImg} />
                            <EcoSection className="product-info" label={i.label} title={handleFormatProductTitle(i)} desc={i.desc} />

                            <EcoButtonDouble
                                className="product-btn"
                                lChildren={['62111365792115', '54714781171785', '54714781204553'].includes(i.variantId) && !isRegular ? '' : t('btn1')}
                                lBtnClick={() => handleBuy(i)}
                                lDisabled={!(i && i.inventoryQuantity && i.inventoryQuantity > 0)}
                                rChildren={t('btn2')}
                                // rDataLayer={{
                                //     event: 'uaEvent',
                                //     event_name: 'select_product',
                                //     list_name: item.title,
                                //     product_name: i.skuTitle,
                                //     button_name: t('btn2'),
                                // }}
                                rBtnClick={() => handleLearnMore(i)}
                                rHref={`https://${locale}.ecoflow.com/products/${i.handle}?variant=${i.variantId}`}
                            />
                        </SwiperSlide>
                    ))}

                    {/* 左右切换按钮 */}
                    <div className="swiper-buttons">
                        <div className="swiper-button-prev swiper-button"></div>
                        <div className="swiper-button-next swiper-button"></div>
                    </div>
                </Swiper>
            )}
            {item?.productInfo && (
                <div className="product-wrapper">
                    <div className="product-content">
                        <EcoImg className="product-img" pc={item.productInfo.img.pc} pad={item.productInfo.img.pad} h5={item.productInfo.img.h5} />
                        <div className="text-wrapper">
                            <EcoSection
                                className="info-section"
                                label={item?.productInfo?.label}
                                title={item?.productInfo?.title || item?.productInfo?.skuTitle}
                                desc={item?.productInfo?.desc}
                            />

                            <EcoButton
                                className="learn-more"
                                lChildren={item?.productInfo?.btn}
                                lHref={item?.productInfo?.herf}
                                lTheme="black"
                                lType="filled"
                                lDataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'select_product',
                                    list_name: item?.productInfo?.label,
                                    product_name: item?.productInfo?.title || item?.productInfo?.skuTitle,
                                    button_name: item?.productInfo?.btn,
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default PcComp;
